import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import AdminDashboard from "../AdminPages/AdminDashboard";
import UploadToken from "../AdminPages/UploadToken";
import AdminSignIn from "../AdminPages/AdminSignIn";
import RequireAuth from "./RequireAuth";

export default function AdminRoutes() {
  const location = useLocation();
  const isLogin = location.pathname === "/admin/sign-in";
  const isAuthed = Boolean(localStorage.getItem("access_token"));
  const showSidebar = !isLogin && isAuthed;

  return (
    <div className="flex">
      {showSidebar && <Sidebar />}
      <div className="flex-1">
        <Routes>
          {/* Public login */}
          <Route path="sign-in" element={<AdminSignIn />} />

          {/* Protected */}
          <Route element={<RequireAuth />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="upload-token" element={<UploadToken />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="sign-in" replace />} />
        </Routes>
      </div>
    </div>
  );
}
